/**
 * Revert of the server's `dehydrateConfig`
 */
export default function hydrateConfig(value) {
  if (value && typeof value === 'object' && typeof value.__fn === 'string') {
    // eslint-disable-next-line no-new-func
    return new Function(`return (${value.__fn})`)()
  }
  if (Array.isArray(value)) return value.map(hydrateConfig)
  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = hydrateConfig(value[key])
      return acc
    }, {})
  }
  return value
}
